import { render, staticRenderFns } from "./USTSideView.vue?vue&type=template&id=71d565cc&scoped=true&"
import script from "./USTSideView.vue?vue&type=script&lang=js&"
export * from "./USTSideView.vue?vue&type=script&lang=js&"
import style0 from "./USTSideView.vue?vue&type=style&index=0&id=71d565cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d565cc",
  null
  
)

export default component.exports